// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Sukg","resendInfoText":"OnGoingPaymentBox_resendInfoText__vuGNc"};